import React from 'react'
import '../../../../assets/scss/components/OnboardingHomepage/onboarding-data-card/onboarding-data-card.css'

const OnboardingDataCard = ({content}) =>{
    /* using dangerouslySetInnerHTML,it is the same as .innerHTML in plain JS. One should
    not use this injection method with data coming from any third party source without
    first sanitizing the data for security. In this case, data comes purely from 
    internal data.js which are all text stored in object form, and there is no user input 
    at any point*/
    
    return (
        <div className="OnboardingDataCard">
            {content.title && <h4 className="OnboardingDataCard-title">{content.title}</h4>}
            
            {content.content?.map((data,index)=>{
                switch(data.type){
                    case 'p':
                    case 'p-noBorder':
                        return <p className={`OnboardingDataCard-${data.type}`} dangerouslySetInnerHTML={{__html:data.text}} key={`OnboardingDataCard-${data.type}-${index}`}></p>
                    case 'link':
                        return (
                        <div className='OnboardingDataCard-linkContainer' key={`OnboardingDataCard-${data.type}-${index}`}>
                            <a href={data.url} target="_blank">{data.text}</a>
                        </div>
                        )
                    case 'card':
                        return (
                        <div className='OnboardingDataCard-card' key={`OnboardingDataCard-${data.type}-${index}`}>
                            <h4 className='OnboardingDataCard-title'>{data.title}</h4>
                            <p className='OnboardingDataCard-card-p' dangerouslySetInnerHTML={{__html:data.text}}></p>
                            <div className='OnboardingDataCard-linkContainer'><a href={data.link} target='_blank'>Learn More</a></div>
                        </div>
                        )
                    case 'list-card':
                        return (
                            <div className="OnboardingDataCard-list-card" key={`OnboardingDataCard-${data.type}-${index}`}>
                                {
                                    data.content.map((subContent)=>{
                                        return (
                                            <div className="OnboardingDataCard-list-card-content" >
                                                <h4 className='OnboardingDataCard-title'>{subContent.subTitle}</h4>
                                                <p dangerouslySetInnerHTML={{__html:subContent.text}}></p>
                                            </div> 
                                        )
                                    })
                                }
                            </div>
                        )
                    case 'img':
                        return <div className="OnboardingDataCard-mediaWrapper" key={`OnboardingDataCard-${data.type}-${index}`}><img src={data.text} alt='' /></div>
                    case 'video':
                        return (
                        <div className='OnboardingDataCard-mediaWrapper' key={`OnboardingDataCard-${data.type}-${index}`}>
                            <iframe src={data.url}
                            frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                        )
                    default:
                        return <div dangerouslySetInnerHTML={{__html:data.text}} ></div>
                }
            })}
        </div>
    )
}

export default OnboardingDataCard